import { render, staticRenderFns } from "./ReportDocumentUpload.vue?vue&type=template&id=016f31f5"
import script from "./ReportDocumentUpload.vue?vue&type=script&lang=ts"
export * from "./ReportDocumentUpload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports